import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import HelpIcon from '@material-ui/icons/LiveHelp'

const getTracker = (name) => {
  if(!window.__nocodeGetTracker) return
  return window.__nocodeGetTracker(name)
}

const openTracker = () => {
  // const chatlio = getTracker('chatlio')
  // if(!chatlio) return
  // chatlio.open()
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(5),
  },
}))

const Help = ({

}) => {
  const classes = useStyles()

  // const chatlio = getTracker('chatlio')

  return (
    <div className={ classes.root }>
      <Paper className={ classes.paper }>
      <Typography gutterBottom>You can email us at <b>support@nocode.works</b></Typography>
      <Typography gutterBottom>Make sure you check out our <a target="_blank" href="https://guide.nocode.works"><b>guide</b></a> which has lots of tips for using nocode.</Typography>
        {/* {
          chatlio && (
            <React.Fragment>
              <Typography gutterBottom>Or you can open our live chat widget:</Typography>
              <p>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={ openTracker }
                >
                  Open live chat&nbsp;&nbsp;&nbsp;<HelpIcon />
                </Button>
              </p>
            </React.Fragment>
          )
        } */}
      </Paper>
    </div>
  )
}

export default Help